import { MetaObject } from '@talisdev/jsonapi-transformers';

export type MetaData<T> = {
  data?: T;
  meta: MetaObject;
};

export const EMPTY_META: MetaData<any> = { meta: {} };
